import Typography from "./ui/typeography/typeography";
import { TallyEmbed } from "./tally-embed";

export function HelpFeedbackPage() {
  return (
    <div className="flex flex-col gap-4 lg:max-w-5xl">
      <Typography variant="h2">We value your feedback!</Typography>
      <Typography variant="p">
        Please use the form below to share your feedback, report a bug, or submit suggestions about the Michigan Trip Planner. Your input helps us improve the application and better serve your transit planning needs.
      </Typography>
      <TallyEmbed />
    </div>
  );
}
